const DOCUMENT = 'SIGNIN_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  TOUCH: DOCUMENT + 'TOUCH',
  SET_FORM_SUBMITTED: DOCUMENT + 'SET_FORM_SUBMITTED',

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  setFormSubmitted: data => ({
    type: actions.SET_FORM_SUBMITTED,
    payload: data,
  }),
};

export default actions;
